"use client";

import { useTranslations } from "next-intl";
import React, { useState } from "react";

import "./TableOfContents.css";

interface Heading {
  id: string;
  text: string;
  tag: string;
}

interface TOCGroup {
  parent: Heading;
  children: Heading[];
}

export default function TableOfContents({ headings }: { headings: TOCGroup[] }) {
  const t = useTranslations();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="toc">
      <button
        className="table-content-heading mb-s font-medium text-l flex justify-between items-center w-full border border-gray-10 p-s"
        onClick={() => setIsOpen((prev) => !prev)}
        aria-expanded={isOpen}
      >
        {t(`article.label.tableOfContent`)}
        <span className="ml-2 transform transition-transform duration-200">{isOpen ? "▲" : "▼"}</span>
      </button>

      <div className={`${isOpen ? "block" : "hidden"} transition-all duration-300`}>
        <ul className="border border-gray-10">
          {headings.map((group) => (
            <li key={group.parent.id} className="p-s pb-0 hover:text-blue-600">
              <a className="block border-b border-gray-10 p-s hover:text-blue-600" href={`#${group.parent.id}`}>
                {group.parent.text}
              </a>
              {group.children.length > 0 && (
                <ul>
                  {group.children.map((child) => (
                    <li key={child.id} className="border-b border-gray-10 p-s hover:text-blue-600">
                      <a className="hover:text-blue-600" href={`#${child.id}`}>
                        {child.text}
                      </a>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
